import authorization from './authorization';
import document from './document';
import tools from './tools';
import importableClient from './importable-client';
import mailUploadedFiles from './mail-uploaded-files';
import openBanking from './open-banking';
import password from './password';
import role from './role';
import uploadedFile from './uploaded-file';
import vatWhitelist from './vat-whitelist';

export default {
  authorization,
  document,
  importableClient,
  mailUploadedFiles,
  openBanking,
  password,
  role,
  tools,
  uploadedFile,
  vatWhitelist,
};
